import Axios from "../config/axios-v1-config";

// Obtener todas las empresas
export const getAllCompanies = async () => {
  const companies = await Axios.get("companies").catch((err) => {
    return { error: err.response.data };
  });

  return companies;
};

// Obtener una empresa por ID
export const getCompany = async (id) => {
  try {
    const response = await Axios.get(`companies/${id}`);
    return response.data; // Retornamos directamente el resultado
  } catch (err) {
    console.error('Error al obtener la compañía:', err);
    return { error: err.response.data };
  }
};

// Crear una nueva empresa
export const createCompany = async (data) => {
  try {
    const response = await Axios.post("companies", data);
    return response.data;
  } catch (err) {
    console.error("Error in createCompany:", err.response?.data || 'Unknown error');
    return { error: err.response?.data || 'Unknown error' };
  }
};

// Actualizar una empresa existente
export const updateCompany = async (id, data) => {
  const updatedCompany = await Axios.put(`companies/${id}`, data).catch((err) => {
    return { error: err.response.data };
  });

  return updatedCompany;
};

// Sube el logo del comercio. Envía dos archivos:
//   - logo: imagen original (PNG/JPG/WEBP) para visualización.
//   - zpl:  PNG normalizado a ≤320×120 que el backend convierte a ^GFA.
// Devuelve { logo, zplLogo, zplPending }. `zplPending: true` significa que la
// imagen se guardó pero el conversor no respondió y el ZPL quedó sin generar.
//
// A diferencia del resto del archivo, NO atrapa el error: LogoUploader necesita
// el rechazo para distinguir un fallo de un guardado exitoso.
export const uploadCompanyLogo = async (id, { logoFile, zplBlob }) => {
  const fd = new FormData();
  fd.append("logo", logoFile, logoFile.name);
  fd.append("zpl", zplBlob, "logo-zpl.png");
  const response = await Axios.patch(`companies/${id}/logo`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Eliminar una empresa
export const deleteCompany = async (id) => {
  const deletedCompany = await Axios.delete(`companies/${id}`).catch((err) => {
    return { error: err.response.data };
  });

  return deletedCompany;
};

// Obtener empresas con paginación y búsqueda
export const getCompaniesPaginated = async (page = 1, limit = 10, searchTerm = "") => {
  let url = `companies-paginated?page=${page}&limit=${limit}`;

  if (searchTerm !== "") {
    url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
  }

  const companies = await Axios.get(url).catch((err) => {
    return { error: err.response.data };
  });

  return companies;
};

export const getActiveClientsApi = async (logisticCompanyId) => {
  try {
    const response = await Axios.post('users/companies/active-contracts', {
      logisticCompanyId,
    }); 

    return response.data; 
  } catch (err) {
    if (err.response && err.response.data) {
      return { error: err.response.data };
    }
    return { error: 'Ocurrió un error al obtener las compañías.' };
  }
};

// Verificar si una empresa existe por su RUT
export const checkCompanyExists = async (businessIdentifier) => {
  try {
    const response = await Axios.post('companies/check', {
      businessIdentifier,
    });
    return response.data;
  } catch (err) {
    console.error('Error checking company existence:', err.response?.data || 'Unknown error');
    return { error: err.response?.data || 'Unknown error' };
  }
};

export const addCompanyShippingAddress = async (companyId, data) => {
  try {
    const response = await Axios.post(
      `contracts/companies/${companyId}/shipping-addresses`,
      data,
    );
    return response.data;
  } catch (err) {
    console.error("Error in addCompanyShippingAddress:", err.response?.data || 'Unknown error');
    return { error: err.response?.data || 'Unknown error' };
  }
};

export const updateCompanyShippingAddress = async (companyId, addressId, data) => {
  try {
    const response = await Axios.patch(
      `contracts/companies/${companyId}/shipping-addresses/${addressId}`,
      data,
    );
    return response.data;
  } catch (err) {
    console.error("Error in updateCompanyShippingAddress:", err.response?.data || 'Unknown error');
    return { error: err.response?.data || 'Unknown error' };
  }
};

// Ficha de la empresa editada por el staff del operador: razón social, RUT, dirección
// fiscal y contactos (principal y de facturación). Body parcial: solo lo que cambió.
// contracts exige un contrato vigente del operador con la empresa (404 si no) y admin
// para cambiar el RUT (403). En error devuelve { error, status }; `status` null = la
// respuesta nunca llegó.
export const updateCompanyProfile = async (companyId, data) => {
  try {
    const response = await Axios.patch(`contracts/companies/${companyId}/profile`, data);
    return response.data;
  } catch (err) {
    console.error("Error in updateCompanyProfile:", err.response?.status ?? "sin respuesta");
    return { error: err.response?.data || "Unknown error", status: err.response?.status ?? null };
  }
};

export const deleteCompanyShippingAddress = async (companyId, addressId) => {
  try {
    const response = await Axios.delete(
      `contracts/companies/${companyId}/shipping-addresses/${addressId}`,
    );
    return response.data;
  } catch (err) {
    console.error("Error in deleteCompanyShippingAddress:", err.response?.data || 'Unknown error');
    return { error: err.response?.data || 'Unknown error' };
  }
};